/**
 * React Query hook for fetching v1 users list
 */

import { useQuery } from '@tanstack/react-query'
import { v1UsersApi, UserListResponse } from '../api'

export function useUsers(page = 1, limit = 10, role?: string, sortBy?: string, sortOrder?: string, email?: string) {
  return useQuery<UserListResponse>({
    queryKey: ['v1', 'users', page, limit, role, sortBy, sortOrder, email],
    queryFn: () => v1UsersApi.getUsers(page, limit, role, sortBy, sortOrder, email),
    staleTime: 30000, // 30 seconds
  })
}
